// Material Dashboard 2 PRO React base styles
import colors from "assets/theme-dark/base/colors";
import borders from "assets/theme-dark/base/borders";
import typography from "assets/theme-dark/base/typography";

const { white } = colors;
const { borderRadius } = borders;
const { size } = typography;

const menuItem = {
  styleOverrides: {
    root: {
      minHeight: "unset",
      padding: "6px 16px",
      borderRadius: borderRadius.md,
      fontSize: size.sm,
      color: white.main,
      transition: "background-color 300ms ease, color 300ms ease",

      "&:hover, &:focus": {
        backgroundColor: "rgba(255, 255, 255, 0.08)",
      },

      "&.Mui-selected, &.Mui-selected:hover, &.Mui-selected:focus": {
        backgroundColor: "rgba(255, 255, 255, 0.16)",
        color: white.main,
      },
    },
  },
};

export default menuItem;
